export default {
	track() {},
};
